import { createReducer } from "@reduxjs/toolkit";
import {
  getQuestionaryListSuccess,
  loadingList,
  setProcedureId,
} from "./questionaryActions";
import {
  updateHasAnyChange,
  updateSaveAndCompleteOrder,
} from "./questionaryProcessActions";

export interface IQuestionaryState {
  dataCount: number;
  isLoading: boolean;
  hasAnyChange: boolean;
  ProcedureId: number;
  saveAndCompleteOrder: boolean;
}

const initialState: IQuestionaryState = {
  dataCount: 0,
  isLoading: false,
  hasAnyChange: false,
  saveAndCompleteOrder: false,
  ProcedureId: 0,
};

export const questionyProcessReducer = createReducer(
  initialState,
  (builder) => {
    builder

      .addCase(updateHasAnyChange, (state, action) => {
        state = {
          ...state,
          hasAnyChange: action.payload,
        };
        return state;
      })
      .addCase(loadingList, (state, action) => {
        state = {
          ...state,
          isLoading: action.payload,
        };
        return state;
      })
      .addCase(setProcedureId, (state, action) => {
        state = {
          ...state,
          ProcedureId: action.payload,
        };
        return state;
      })
      .addCase(updateSaveAndCompleteOrder, (state, action) => {
        state = {
          ...state,
          saveAndCompleteOrder: action.payload,
        };
        return state;
      });
  }
);
